import { render, staticRenderFns } from "./NewsLetterList.vue?vue&type=template&id=4582ca36&scoped=true&"
import script from "./NewsLetterList.vue?vue&type=script&lang=js&"
export * from "./NewsLetterList.vue?vue&type=script&lang=js&"
import style0 from "./NewsLetterList.vue?vue&type=style&index=0&id=4582ca36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4582ca36",
  null
  
)

export default component.exports